export default "/images/vendor/flag-icon-css/flags/4x3/tn.svg?8eab019ab85837b171c253f4156f4db5";